module.exports = __webpack_public_path__ + "img/ic_polygon.538402fc.svg";